import OldUrls from "../../models/utils/OldUrls";
import IconExternalLink from "../icon/IconExternalLink";
import DateTimeFormatter from "../../models/formatter/DateTimeFormatter";
import Attribute from "./Attribute";
import AttendeeAddress from "../../ui/AttendeeAddress";
import {PaidAmount} from "./PaidAmount";
import PriceFormatter from "../../models/formatter/PriceFormatter";
import React from "react";
import {AttendeeScreenData} from "../../scenes/app/attendees/AttendeeDetailScene";

type Props = {
  attendee: AttendeeScreenData
}

export default function ContactInfoTab({attendee}: Props) {
  return (
    <>
      <div className="flex items-center mt-6">
        <h3 className="text-2xl font-bold">{attendee.event.title}</h3>
        <a href={OldUrls.event(Number(attendee.event.id))}><IconExternalLink
          className="text-gray-dark ml-2"/></a>
      </div>
      <div className="mb-5">
        {attendee.source} {attendee.created &&
        <span className="text-gray-dark"> • {DateTimeFormatter.formatISO(attendee.created)}</span>
      }
      </div>
      <div className="bg-white overflow-hidden py-5 pt-3 grid grid-cols-11">
        <div className="col-start-1 col-span-5">
          <div className="pb-3">
            <h3 className="text-2xl font-bold">Contact info</h3>
          </div>
          <div className="">
            <dl>
              <Attribute name="Home address">
                <AttendeeAddress type="home" address={attendee.homeAddress}/>
              </Attribute>
              <Attribute name="Phone">{attendee.phone || '—'}</Attribute>
              <Attribute name="Date of birth">{attendee.birthDate || '—'}</Attribute>
              <Attribute name="Company role">{attendee.companyRole || '—'}</Attribute>
              <Attribute name="Comment">{attendee.comment || '—'}</Attribute>
              {attendee.memberId &&
                <Attribute name="Member Id">{attendee.memberId}</Attribute>
              }
              {attendee?.customFields?.map((field, idx) =>
                <div key={idx} className="grid grid-cols-3 gap-4 py-1.5">
                  <dt className="text-gray-dark">{field?.label}</dt>
                  <dd className="col-span-2">{field?.value}</dd>
                </div>
              )}
              {attendee?.consents?.map((consent, idx) =>
                <div key={idx} className="p-2 bg-gray-light rounded-md my-2">
                  {consent?.accepted ?
                    <dt className="text-green opacity-40">Accepted</dt> :
                    <dt className="text-red opacity-40">Rejected</dt>
                  }
                  <dd className="pt-2">
                    <div dangerouslySetInnerHTML={{__html: consent?.content || ''}}/>
                  </dd>
                </div>
              )}
            </dl>
          </div>
        </div>
        <div className="border-l-2 mx-10 border-gray-light"></div>
        <div className="col-start-7 col-span-5">
          <div className="pb-3">
            <h3 className="text-2xl font-bold">Payment information</h3>
          </div>
          <div className="">
            <dl>
              <Attribute name="Billing address">
                <AttendeeAddress type="billing" address={attendee.billingAddress}/>
              </Attribute>
              <Attribute name="Company address">
                <AttendeeAddress type="billing" address={attendee.companyAddress}/>
              </Attribute>
              <Attribute name="Company">{attendee.company || '—'}</Attribute>
              {!attendee.event.isFree &&
                <>
                  <Attribute name="Paid amount">
                    <PaidAmount amount={attendee.paidAmount || 0}
                                currency={attendee.paidCurrency || ''}
                                details={attendee.detailedPaidAmount}/>
                  </Attribute>
                  <Attribute name="Payment method">
                    {attendee.paymentMethod}
                    {attendee.bankCard && (
                      <span>(
                        {attendee.bankCard.brand} ****{attendee.bankCard.last4}
                        )</span>
                    )}
                  </Attribute>
                </>
              }
              {!attendee.event.isFree && attendee.ticketType &&
                <Attribute name="Ticket type">
                  {attendee.ticketType?.name} {PriceFormatter.format({
                  currency: attendee.ticketType?.currency,
                  amount: attendee.ticketType?.amount
                })}
                </Attribute>
              }
              {attendee.billingTaxName &&
                <Attribute name="Tax name">{attendee.billingTaxName}</Attribute>
              }
              {attendee.billingTaxNumber &&
                <Attribute name="Tax number">{attendee.billingTaxNumber}</Attribute>
              }
              {attendee.promoCode &&
                <Attribute name="Promo code">{attendee.promoCode}</Attribute>
              }
              {attendee.referral &&
                <Attribute name="Referral code">{attendee.referral}</Attribute>
              }
            </dl>
          </div>
        </div>
      </div>
    </>
  );
}
